import { Map } from 'maplibre-gl';
import { GeoJSON } from 'geojson';
import * as turf from '@turf/turf';
import { ScoutLocation } from '@/types/location';

export const CENTROID_SOURCE_ID = 'hm-demo-centroid-data';
export const POLYGON_SOURCE_ID = 'hm-demo-polygon-data';

export async function addSource(map: Map, locations: ScoutLocation[]) {
  if (
    map &&
    !map.getSource(CENTROID_SOURCE_ID) &&
    !map.getSource(POLYGON_SOURCE_ID)
  ) {
    try {
      const centroidCollection: GeoJSON = {
        type: 'FeatureCollection',
        features: locations.map((location: ScoutLocation) => {
          const centroid = turf.centroid(location.geojson as turf.AllGeoJSON);
          return {
            type: 'Feature',
            properties: {
              id: location._id,
              name: location.name,
            },
            geometry: {
              type: 'Point',
              coordinates: [
                centroid.geometry.coordinates[0],
                centroid.geometry.coordinates[1],
              ],
            },
          };
        }),
      };

      const polygonCollection: GeoJSON = {
        type: 'FeatureCollection',
        features: locations
          .filter(location => location.segments)
          .map(location => ({
            type: 'Feature',
            properties: {
              id: location._id,
              name: location.name,
            },
            geometry: location.segments!,
          })),
      };

      map.addSource(CENTROID_SOURCE_ID, {
        type: 'geojson',
        data: centroidCollection,
        promoteId: 'id',
      });

      map.addSource(POLYGON_SOURCE_ID, {
        type: 'geojson',
        data: polygonCollection,
        promoteId: 'id',
      });
    } catch (err) {
      console.log(err);
    }
  }
}
